import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { PaymentTerm } from "../../models/payment-term.model";

export namespace PaymentTermActions {

  @logDispatcher
  export class GetPaymentTerms {
    static readonly type = '[PaymentTerm] GetPaymentTerms';
    constructor() { }
  }

  @logDispatcher
  export class GetPaymentTermsSuccess {
    static readonly type = '[PaymentTerm] GetPaymentTermsSuccess';
    constructor(public paymentTerms: PaymentTerm[]) { }
  }

  @logDispatcher
  export class GetPaymentTermsFail {
    static readonly type = '[PaymentTerm] GetPaymentTermsFail';
    constructor(public error: any) { }
  }
}
